import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { slotTemplateQKeys } from "@hooks/queries/slotTemplate/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface DailyTimeBlock {
  start_time: string;
  end_time: string;
  slot_duration_minutes: number;
  buffer_time_minutes: number;
}

interface CreateSlotTemplateData {
  name: string;
  description?: string;
  doctor_assigned: string;
  daily_schedule: Record<number, DailyTimeBlock[]>;
  recurrence: {
    type: "daily" | "weekly" | "specific_days";
    days_of_week?: number[];
    start_date: string;
    end_date?: string | null;
  };
  slot_config: {
    quantity: number;
    default_booked: boolean;
    booking_lead_time_minutes?: number;
  };
  is_active: boolean;
  generation_horizon_days: number;
}

export const useCreateSlotTemplate = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (data: CreateSlotTemplateData) => {
      return api.post(`slot-templates/`, data);
    },
    onSuccess: () => {
      showSuccessNotification({ message: "slot-template-created-success" });
      queryClient.invalidateQueries({ queryKey: slotTemplateQKeys.all() });
    },

    onError: (res: any) => {
      console.error("[From Create Slot Template]", res);
      queryClient.invalidateQueries({ queryKey: slotTemplateQKeys.all() });
      handleErrors(res, "mutation");
    },
  });
};
